<template>
  <div class="lista_tareas_wrapper">
    <div class="lista_tareas_body">
      <section class="body_header">
        <p class="header_title">Lista de Tareas</p>
      </section>
      <section class="body_content">
        <Container
          class="tareas_list"
          drag-handle-selector=".dragicon"
          non-drag-area-selector=".item-first-content"
          :get-child-payload="getChildPayload"
          @drag-start="onDragStart"
          @drop="onDrop"
        >
          <Draggable
            id="hidden-drag-ghost-list"
            v-for="(task, index) in listaTareasComp"
            :key="index"
          >
            <div class="tareas_list-item">
              <div class="dragiconbox">
                <div class="dragicon">
                  <i class="handle material-icons">more_horiz</i>
                </div>
              </div>
              <div class="item-first-content">
                <div class="item-info">
                  <b-input
                    class="input-custom item-info__input"
                    placeholder="Nombre de Tarea"
                    v-model="task.name"
                    @blur="changeName(task.name, index)"
                    :disabled="!role"
                  ></b-input>
                  <div class="item-info__btn-content">
                    <div class="item_tipo_tarea">
                      <b-select
                        placeholder="Tipo de tarea"
                        class="input-select-custom select-custom-no"
                        v-model="task.labeltype"
                        @input="changeTipo(task, index)"
                        :disabled="!role"
                      >
                        <option value="well-bad">Bien/Mal - Opción Única</option>
                        <option value="well-bad-m">Bien/Mal - Opción Multiple</option>
                        <option value="percentage">Porcentaje</option>
                        <option value="number">Numérico</option>
                        <option value="pressure">Presión</option>
                        <option value="voltage">Voltaje</option>
                        <option value="farenheit">T-Farenheit</option>
                        <option value="celcius">T-Celcius</option>
                        <option value="time">Tiempo Horas</option>
                      </b-select>
                    </div>
                    <div class="item_borrar">
                      <div class="content-link">
                        <a
                          @click.prevent.stop
                          @click="preventDialogListTareas(index)"
                          class="button button-custom-actions ripple wrap-content-btn"
                          :disabled="!role"
                        >
                          <i class="item_icon item_icon-red material-icons">close</i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="item-btn-alternative"
                  @click="addAlternativas(index)"
                  v-if="task.labeltype=='well-bad'"
                >
                  <div class="item-btn-alternative--addOption">
                    <i class="item_icon material-icons">add</i>
                  </div>
                  <span>Alternativas</span>
                </div>
              </div>

              <div class="item-character" v-if="task.type=='range'">
                <div class="range_class">
                  <label for="minRange">Mínimo</label>
                  <b-input
                    id="minRange"
                    size="is-medium"
                    class="input-custom item-info__input"
                    label="Minimo"
                    type="number"
                    v-model="task.minRange"
                    @blur="changeRange(task.minRange, index, 'minimo')"
                  ></b-input>
                </div>
                <div class="range_class">
                  <label for="maxRange">Máximo</label>
                  <b-input
                    id="maxRange"
                    size="is-medium"
                    class="input-custom item-info__input"
                    label="Maximo"
                    type="number"
                    v-model="task.maxRange"
                    @blur="changeRange(task.maxRange, index, 'maximo')"
                  ></b-input>
                </div>
              </div>
              <div class="item-character" v-if="task.labeltype == 'well-bad'">
                <!-- <b-input class="input-custom item-character__input" v-for="(item, index) in task.alternatives" :key="index" v-model="item.value" @blur="changeAlternativa(item.value, task.id, index)" :disabled="!role">
                  
                </b-input>-->
                <div
                  class="control input-custom item-character__input is-clearfix"
                  v-for="(item, index) in task.alternatives"
                  :key="index"
                >
                  <input
                    type="text"
                    autocomplete="on"
                    class="input"
                    v-model="item.value"
                    @blur="changeAlternativa(item.value, task.id, index)"
                    :disabled="!role"
                  >
                  <i
                    class="material-icons"
                    @click="delAlternative(task.id, index)"
                    v-if="role"
                  >close</i>
                </div>
              </div>
            </div>
          </Draggable>
        </Container>
      </section>
      <div class="tareas_add">
        <div class="content-link">
          <a
            @click.prevent.stop
            @click="postTask"
            class="button button-custom-actions ripple"
            :disabled="!role"
          >
            <i class="item_icon material-icons">add</i>Agregar Tarea
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
// import draggable from "vuedraggable";
import { Container, Draggable } from "vue-smooth-dnd";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "listaTareas",
  components: {
    headView,
    Draggable,
    Container
  },
  props: ["currentStep"],
  data() {
    return {
      title: {
        headText: "Puntos de Control",
        subtitle: ""
      },
      subtitleOpt: false,
      selected: [],
      alternativas_bool: false,
      tarea: {
        nombre: []
      },
      alt: [],
      maxRan: [],
      minRan: []
    };
  },
  watch: {
    alternativas: function() {
      if (this.alternativas.length > 0) {
        this.alternativas_bool = true;
      }
      if (this.alternativas.length == 0) {
        this.alternativas_bool = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "listaTareas",
      "cp_id",
      "alternativas",
      "taskById",
      "taskByIndex",
      "role"
    ]),
    listaTareasComp: {
      get() {
        if (this.listaTareas) {
          return this.listaTareas.sort(function(a, b) {
            return a.order - b.order;
          });
        }
      },
      set(value) {
        this.$store.commit("addTasks", value);
        var obj = value.map(v => v.id);
        if (this.$route.params.id) {
          this.$store.dispatch("SETORDERTASKS", {
            id: this.$route.params.id,
            tasks: obj
          });
        } else {
          this.$store.dispatch("SETORDERTASKS", { id: this.cp_id, tasks: obj });
        }
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      for (var ts in this.listaTareas) {
        this.tarea.nombre[ts] = this.listaTareas[ts].name;
        this.selected[ts] = this.listaTareas[ts].labeltype;
        if (this.listaTareas[ts].type == "range") {
          this.minRan[ts] = this.listaTareas[ts].minRange;
          this.maxRan[ts] = this.listaTareas[ts].maxRange;
          this.range_bool = true;
        }
      }
    }

    if (this.cp_id) {
      for (var ts in this.listaTareas) {
        this.tarea.nombre[ts] = this.listaTareas[ts].name;
        this.selected[ts] = this.listaTareas[ts].labeltype;
        if (this.listaTareas[ts].type == "range") {
          this.minRan[ts] = this.listaTareas[ts].minRange;
          this.maxRan[ts] = this.listaTareas[ts].maxRange;
          this.range_bool = true;
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      "addTaskType",
      "addTask",
      "addTaskName",
      "addTaskRangeMin",
      "addTaskRangeMax",
      "addAlternativas",
      "addAlternativa",
      "udAlternativa",
      "delAlternativa",
    ]),
    changeTipo: function(task, index) {
      if (task.labeltype === "well-bad") {
        task.type = "status";
      } else if (task.labeltype === "well-bad-m") {
        task.type = "multistatus";
        task.labeltype = "well-bad";
      } else {
        task.type = "range";
      }
      var payload = {
        type: task.type,
        labeltype: task.labeltype,
        i: index
      };
      this.addTaskType(payload);
      if (this.$route.params.id) {
        this.$store.dispatch("PUTTASK", {
          id_cp: this.$route.params.id,
          id_ts: this.listaTareas[index].id,
          obj: this.listaTareas[index]
        });
      } else {
        this.$store.dispatch("PUTTASK", {
          id_cp: this.cp_id,
          id_ts: this.listaTareas[index].id,
          obj: this.listaTareas[index]
        });
      }
    },
    changeName: function(nom, index) {
      var payload = {
        name: nom,
        i: index
      };
      this.addTaskName(payload);
      if (this.$route.params.id) {
        this.$store.dispatch("PUTTASK", {
          id_cp: this.$route.params.id,
          id_ts: this.listaTareas[index].id,
          obj: this.listaTareas[index]
        });
      } else {
        this.$store.dispatch("PUTTASK", {
          id_cp: this.cp_id,
          id_ts: this.listaTareas[index].id,
          obj: this.listaTareas[index]
        });
      }
      this.$store.dispatch("PUTTASK", {
        id_cp: this.cp_id,
        id_ts: this.listaTareas[index].id,
        obj: this.listaTareas[index]
      });
    },
    changeRange: function(value, index, type) {
      var payload = {
        range: value,
        i: index
      };
      if (type === "minimo") {
        this.addTaskRangeMin(payload);
      }
      if (type === "maximo") {
        this.addTaskRangeMax(payload);
      }
      if (this.$route.params.id) {
        this.$store.dispatch("PUTTASK", {
          id_cp: this.$route.params.id,
          id_ts: this.listaTareas[index].id,
          obj: this.listaTareas[index]
        });
      } else {
        this.$store.dispatch("PUTTASK", {
          id_cp: this.cp_id,
          id_ts: this.listaTareas[index].id,
          obj: this.listaTareas[index]
        });
      }
    },
    postTask: function() {
      var task = {
        name: "tarea",
        labetype: "",
        type: "",
        minRange: 0,
        maxRange: 0
      };
      if (this.$route.params.id) {
        this.$store
          .dispatch("POSTTASK", { id_cp: this.$route.params.id, obj: task })
          .then(r => {
            this.success();
          });
      } else {
        this.$store
          .dispatch("POSTTASK", { id_cp: this.cp_id, obj: task })
          .then(r => {
            this.success();
          });
      }
    },
    preventDialogListTareas(index) {
      this.$dialog.confirm({
        title: "Punto de Control",
        message:
          "Se eliminará la tarea selecionada.</br> <strong>¿Desea continuar?</strong>",
        confirmText: "Ok",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.delTask(index)
      });
    },
    delTask: function(index) {
      this.$store
        .dispatch("DELETETASK", { id_ts: this.listaTareas[index].id })
        .then(r => {
          if (this.$route.params.id) {
            this.$store.dispatch("GETTASKS", this.$route.params.id);
            this.$toast.open({
              message: "Tarea eliminada",
              position: "is-bottom-right",
              type: "ffcolor-is-delete"
            });
          }
          if (this.cp_id) {
            this.$store.dispatch("GETTASKS", this.cp_id);
            this.$toast.open({
              message: "Tarea eliminada",
              position: "is-bottom-right",
              type: "ffcolor-is-delete"
            });
          }
        });
    },
    addAlternativas: function(index) {
      if (this.role) {
        let new_alt = "Nueva Alternativa";
        this.$store
          .dispatch("POSTALTERNATIVE", {
            id_task: this.listaTareas[index].id,
            str: new_alt
          })
          .then(r => {
            this.successAlt();
          });
      }
    },
    changeAlternativa: function(val, id, index) {
      this.udAlternativa({ val, id, index });
      this.$store.dispatch("PUTALTERNATIVE", {
        id_task: this.alternativas(id)[index].task,
        id_alt: this.alternativas(id)[index].id,
        str: val
      });
    },
    delAlternative: function(id, index) {
      this.$store
        .dispatch("DELALTERNATIVE", {
          id_task: id,
          id_alt: this.alternativas(id)[index].id
        })
        .then(r => {
          this.delAlternativa({ id, index });
        });
    },
    success() {
      this.$toast.open({
        message: "Tarea creada",
        position: "is-bottom-right",
        type: "ffcolor-is-success"
      });
    },
    successAlt() {
      this.$toast.open({
        message: "Alternativa agregada",
        position: "is-bottom-right",
        type: "ffcolor-is-success"
      });
    },
    sortTasks(array, oldIndex, newIndex) {
      let newArray = JSON.parse(JSON.stringify(array));
      let result = [];
      if (newIndex > oldIndex) {
        result.push(...newArray.slice(0, oldIndex));
        for (let i of newArray.slice(oldIndex + 1, newIndex + 1)) {
          i.order = i.order - 1;
        }
        result.push(...newArray.slice(oldIndex + 1, newIndex + 1));
        newArray[oldIndex].order = newIndex;
        result.push(newArray[oldIndex]);
        // for(let i of newArray.slice(newIndex)){
        //   i.order = i.order + 1;
        // }
        result.push(...newArray.slice(newIndex + 1));
      }
      if (newIndex < oldIndex) {
        result.push(...newArray.slice(0, newIndex));
        newArray[oldIndex].order = newIndex;
        result.push(newArray[oldIndex]);
        for (let i of newArray.slice(newIndex, oldIndex)) {
          i.order = i.order + 1;
        }
        result.push(...newArray.slice(newIndex, oldIndex));
        result.push(...newArray.slice(oldIndex + 1));
      }
      return result;
    },
    onDrop(dropResult) {
      var value;
      if (dropResult.removedIndex != dropResult.addedIndex) {
        value = this.sortTasks(
          this.listaTareas,
          dropResult.removedIndex,
          dropResult.addedIndex
        );
      } else {
        value = this.listaTareas;
      }

      this.$store.commit("addTasks", value);
      var obj = value.map(v => v.id);

      if (this.$route.params.id) {
        this.$store.dispatch("SETORDERTASKS", {
          id: this.$route.params.id,
          tasks: obj
        });
      } else {
        this.$store.dispatch("SETORDERTASKS", { id: this.cp_id, tasks: obj });
      }
    },
    getChildPayload(index) {
      return this.listaTareas[index];
    },
    onDragStart(index) {}
  }
};
</script>
<style lang="scss">
@import "../../assets/styles/2.tools/mixins/_mediaquerys.scss";
.lista_tareas_wrapper {
  margin-bottom: 40px;
}
.lista_tareas_body {
  // padding-top: 70px;
  padding: 0;
  @include media-xl() {
    padding: 0 200px 0 30px;
  }
  // max-width: 700px;
  // height: 100%;
}
.body_header {
  width: 100%;
}
.body_content {
  // margin-top: 25px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.tareas_list,
.tareas_list-item,
.tareas_add {
  width: 100%;
}
.tareas_add {
  // margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tareas_list-item {
  // max-width: 600px;
  // display: flex;
  // justify-content: flex-start;
  // align-items: center;
  font-size: 18px;
  margin-bottom: 30px;
  padding: 20px;
  padding-top: 0;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  background-color: #dbdbdb;
}
.item_icon-red {
  color: red;
}
.select-custom-no {
  margin-bottom: 0px !important;
  border-color: #e6e4e6;
}
.content-link {
  // box-shadow: 0px 0px 0.5px 0px rgba(0, 0, 0, 0.75);
  border-radius: 4px;
  &--addTask {
    background-color: #1abc9c;
  }
}
.item_borrar {
  margin-left: 20px;

  .wrap-content-btn {
    background-color: white;
    padding: 23px 20px;
  }
}

.header_title {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  margin: 0;
  padding-left: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}

.item-info {
  width: 100%;
  // margin-bottom: 2%;
  &__input {
    min-width: 48%;
    margin-right: 2%;
    height: 50px;
    input {
      height: 100%;
    }
  }
  &__btn-content {
    min-width: 48%;
    display: flex;
    justify-content: space-between;
    .item_tipo_tarea {
      width: 100%;
      .control {
        .select {
          height: 3em;
          select {
            height: 3.2em;
          }
        }
      }
    }
  }
}
.item-character {
  // flex: 1;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  &__input {
    // border: 1px #fd5961 dashed;
    min-width: 48%;
    margin-right: 4%;
    margin-bottom: 3%;
    border-radius: 4px;
    outline: 2px dashed #fd5961;
    outline-offset: -1px;
    position: relative;
    &:hover {
      outline: 2px solid #fd5961;
    }
    input {
      color: #5e5e5e;
      font-size: 1rem;
      border: transparent;
    }
    i {
      position: absolute;
      font-size: 12px;
      right: 5px;
      bottom: 12px;
      color: red;
      cursor: pointer;
    }
    &:nth-child(2n) {
      margin-right: 0;
    }
    p {
      font-size: 16px;
    }
  }
  @include media-md() {
    justify-content: space-between;
  }
}
.item-first-content {
  // flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  .item-info {
    display: flex;
    justify-content: space-between;
  }
}
.item-btn-alternative {
  // transform: scale(0.7);
  // position: relative;
  // left: 0;
  margin-bottom: 1rem;
  cursor: pointer;
  // width: 110px;
  // text-align: start;
  // font-size: 15px;
  // margin-top: -30px;
  // margin-left: 5px;
  // margin-bottom: 10px;
  // cursor: pointer;
  // i {
  //   // font-size: 15px;
  //   // padding-top: 3px;
  // }
  span {
    color: #5e5e5e;
  }
  &--addOption {
    // background-color: white;

    // margin-left: 10px;
    // padding: 10px;
    float: left;
    position: relative;
    width: 25px;
    height: 25px;
    margin-right: 5px;

    border-radius: 50%;
    border: 1px solid #384a5d;
    i {
      color: #384a5d;
      // padding: 0 3px;
      display: block;
      position: absolute;
      top: 50%;
      width: 24px;
      height: 18px;
      transform: translateY(-50%);

      font-size: 16px;
    }

    // border-color: #384a5d;
    // background-color: white;
    // font-size: 12px;
    // i {
    //   color: #384a5d;
    //   font-size: 14px;
    // }
  }
}
.range_class {
  color: #5e5e5e;
}
.dragiconbox {
  color: #5e5e5e;
  direction: ltr;
  text-align: left;
  height: 24px;
  overflow: hidden;
  width: 24px;
  display: inline-block;
  position: relative;
  cursor: move;
}
.dragicon {
  direction: ltr;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/listaTareas.vue